import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './warranty-claim-card-skeleton.module.scss';

export type WarrantyClaimCardSkeletonProps = {
  /** Number of placeholder cards to render. Defaults to 6. */
  count?: number;
};

/**
 * Loading placeholder for the Warranty Claims listing. Mirrors the real
 * `WarrantyClaimsGrid` layout (`WarrantyClaimCard`): a centered image block, a status-chip
 * row, the device name and the "Last updated" line — so the swap to real cards is seamless.
 */
export function WarrantyClaimCardSkeleton({ count = 6 }: WarrantyClaimCardSkeletonProps) {
  return (
    <div className={styles.grid} aria-busy="true" aria-label="Loading warranty claims">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.card} data-testid="warranty-claim-card-skeleton">
          <span className={styles.imageWrap}>
            <SkeletonBlock width={120} height={110} radius={12} />
          </span>
          <SkeletonBlock width={88} height={22} radius={24} />
          <SkeletonBlock width="60%" height={16} />
          <SkeletonBlock width="45%" height={12} />
        </div>
      ))}
    </div>
  );
}
